/**
 * Utility functions for formatting data
 */

/**
 * Format barcode with spacing for better readability
 * @param {string} barcode - Raw barcode string
 * @returns {string} Formatted barcode
 */
export function formatBarcode(barcode) {
  if (!barcode) return '';
  const cleaned = barcode.replace(/\s/g, '');
  if (cleaned.length === 12) {
    return `${cleaned[0]} ${cleaned.slice(1, 6)} ${cleaned.slice(6, 11)} ${cleaned[11]}`;
  }
  if (cleaned.length === 13) {
    return `${cleaned[0]} ${cleaned.slice(1, 7)} ${cleaned.slice(7, 13)}`;
  }
  return barcode;
}

/**
 * Format weight display (shows "Not set" for 0 or null)
 * @param {number} weight - Weight value
 * @param {string} unit - Unit (default 'g')
 * @returns {string} Formatted weight string
 */
export function formatWeight(weight, unit = 'g') {
  if (!weight || weight === 0 || weight === '0') {
    return 'Not set';
  }
  return `${weight} ${unit}`;
}

/**
 * Format SKU for display
 * @param {string} sku - SKU value
 * @returns {string} Formatted SKU
 */
export function formatSKU(sku) {
  return sku || 'N/A';
}

/**
 * Format stock display with committed stock
 * @param {number} available - Available stock
 * @param {number} committed - Committed stock
 * @returns {string} Formatted stock string
 */
export function formatStock(available, committed = 0) {
  const stock = available || 0;
  if (committed > 0) {
    return `${stock} (A:${committed})`;
  }
  return `${stock}`;
}

/**
 * Truncate text to specified length
 * @param {string} text - Text to truncate
 * @param {number} maxLength - Maximum length
 * @returns {string} Truncated text
 */
export function truncateText(text, maxLength = 50) {
  if (!text) return '';
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
}
